import React, {Suspense} from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Lottie from 'lottie-react-web'
import './assets/Fonts/Montserrat.css';
import loader from './assets/images/loader.json';

import {in_array} from './modules/Functions';

import routes from "./routes";
import {Provider} from 'react-redux';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/main.css";
import Https from "./services/api/apiClient";

import configureStore from './store';

import {PersistGate} from 'redux-persist/integration/react'
import mobileAndTabletcheck from "./utils/device";
import {cookieCheck} from './utils/device';

import AOS from 'aos';
import 'aos/dist/aos.css';

// TURNING OFF ALL CONSOLE LOGS
//console.log = console.warn = console.error = () => {};

const {store, persistor} = configureStore();
// init animation library
AOS.init();
// check for mobile
mobileAndTabletcheck();
// check for cookies to set
cookieCheck();
const renderLoader = () => {
  return (<div
      style={{position: "fixed", left: "50%", top: "50%", marginLeft: "-35px"}}>
      {/*eslint-disable-next-line*/}
      <Lottie
        width={70}
        options={{
          animationData: loader,
        }}
      /></div>
  )
};

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

  return (
    <Provider store={store}>
      <PersistGate
        onBeforeLift={() => {
          Https.setAccessToken(store.getState().authentication.accessToken)
        }}
        persistor={persistor}>
        <Router basename={process.env.REACT_APP_BASENAME || ""}>
          <Suspense fallback={renderLoader()}>
            <Switch>
              {routes.map((route, index) => {
                return (
                  <Route
                    status={(route.status && route.status === 404) ? 404 : 200}
                    key={index}
                    path={route.path}
                    exact
                    component={props => {
                      return (
                        <route.layout {...props}>
                          <route.component {...props} />
                        </route.layout>
                      );
                    }}
                  />
                );
              })}
            </Switch>
          </Suspense>
        </Router>
      </PersistGate>
    </Provider>
  );
}
